import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import type { ClassValue } from "clsx";

export type Prettify<T> = {
  [K in keyof T]: T[K];
} & {};

export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs));
}

export function formatFileSize(
  bytes: number,
  base: "binary" | "decimal" = "binary",
  dp: number = 1,
): string {
  const thresh = base === "decimal" ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return `${bytes} B`;
  }

  const units =
    base === "decimal"
      ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let unit = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++unit;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    unit < units.length - 1
  );

  return bytes.toFixed(dp) + units[unit];
}
